export default __webpack_public_path__ + "static/media/plateIconEmpty.34287607.svg";